export const formatTemperature = (value: number) => value.toFixed(2);

export const celsiusToFahrenheit = (celsius: number) => celsius * 1.8 + 32;
